// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2GPJa","col":"Table_col__pNP_l","fulfillmentStatus":"Table_fulfillmentStatus__VarWq","emailCol":"Table_emailCol__2YtVD"};